import type { ReactNode } from 'react';

type SectionProps = {
  id: string;
  eyebrow: string;
  title: string;
  description?: string;
  children: ReactNode;
  tone?: 'light' | 'dark';
  className?: string;
};

export function Section({ id, eyebrow, title, description, children, tone = 'light', className = '' }: SectionProps) {
  return (
    <section id={id} className={`section section-${tone} ${className}`}>
      <div className="section-inner">
        <div className="section-heading">
          <p className="eyebrow">{eyebrow}</p>
          <h2>{title}</h2>
          {description ? <p>{description}</p> : null}
        </div>
        {children}
      </div>
    </section>
  );
}
